// extracted by mini-css-extract-plugin
export default {"cardsContainer":"ProductAnalyticsPage_cardsContainer__N1HAD","cardRow":"ProductAnalyticsPage_cardRow__ktmc1","mainContent":"ProductAnalyticsPage_mainContent__BUaZ1"};